// Single, dedicated construction site for the `dispatchLegacyEvent` service,
// so every Config assembler that needs it (today: pageConfig.ts) references
// the same implementation instead of re-inlining it.
export const dispatchLegacyEvent = (eventName: keyof typeof Wahanda.Event, data?: any): void => {
  App.trigger(Wahanda.Event[eventName], data);
};
